import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

// Helper function to safely parse data that might be a string or already parsed
const safeParse = (data) => {
  if (!data) return [];
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error("Failed to parse data:", e);
      return [];
    }
  }
  return Array.isArray(data) ? data : [];
};

const EmploymentTypeModal = ({
  show,
  onHide,
  value = [],
  onSave,
  isApplyPage = false,
  shouldUpdateProfile = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedTypes, setSelectedTypes] = useState([]);
  const [error, setError] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  const employmentOptions = [
    { value: "Full-time", label: "Full-time" },
    { value: "Part-time", label: "Part-time" },
    { value: "Contract", label: "Contract" },
    { value: "Temporary", label: "Temporary" },
    { value: "Per Diem", label: "Per Diem" },
  ];

  // Load existing employment types
  useEffect(() => {
    console.log("useEffect triggered:", { show, isApplyPage, isInitialized });
    if (!show) {
      setIsInitialized(false); // reset when modal closes
      return;
    }

    if (isInitialized) {
      console.log("Skipping useEffect - already initialized");
      return; // ✅ prevent override after user edits
    }

    if (isApplyPage) {
      const mapped = employmentOptions.filter((opt) =>
        (value || []).includes(opt.value),
      );
      console.log("Setting selectedTypes from apply page:", mapped);
      setSelectedTypes(mapped);
    } else {
      const types = safeParse(
        store?.profileItem?.data?.nurseProfile?.employment_types,
      );
      console.log("Parsed employment types from profile:", types);

      const mapped = employmentOptions.filter((opt) =>
        types.includes(opt.value),
      );
      console.log("Setting selectedTypes from profile:", mapped);
      setSelectedTypes(mapped);
    }

    setIsInitialized(true); // ✅ mark initialized
  }, [show, isApplyPage, value, store?.profileItem?.data?.nurseProfile?.employment_types]);
  // useEffect(() => {
  //   if (!show) return;

  //   if (isApplyPage) {
  //     const mapped = employmentOptions.filter((opt) =>
  //       (value || []).includes(opt.value),
  //     );
  //     setSelectedTypes(mapped);
  //   } else {
  //     const types =
  //       store?.profileItem?.data?.nurseProfile?.employment_types || [];

  //     const mapped = employmentOptions.filter((opt) =>
  //       types.includes(opt.value),
  //     );

  //     setSelectedTypes(mapped);
  //   }
  // }, [show, isApplyPage]);

  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  // Toggle selection
  const handleSelect = (type) => {
    console.log("handleSelect called with:", type);
    setIsInitialized(true); // ✅ mark as user interaction
    setSelectedTypes((prev) => {
      console.log("Previous selectedTypes:", prev);
      const exists = prev.some((t) => t.value === type.value);

      if (exists) {
        const newTypes = prev.filter((t) => t.value !== type.value);
        console.log("New selectedTypes after removal:", newTypes);
        return newTypes;
      }

      const newTypes = [...prev, type];
      console.log("New selectedTypes after addition:", newTypes);
      return newTypes;
    });

    setError("");
  };

  const handleSave = () => {
    if (selectedTypes.length === 0) {
      setError("Please select at least one employment type");
      return;
    }

    const selectedValues = selectedTypes.map((t) => t.value);

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(selectedValues);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("employment_types", JSON.stringify(selectedValues));

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("employment_types", JSON.stringify(selectedValues));

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (selectedTypes.length === 0) {
  //     setError("Please select at least one employment type");
  //     return;
  //   }

  //   const selectedValues = selectedTypes.map((t) => t.value);

  //   if (isApplyPage) {
  //     // ✅ LOCAL UPDATE
  //     onSave(selectedValues);
  //     onHide();
  //   } else {
  //     // ✅ API CALL
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("employment_types", JSON.stringify(selectedValues));

  //     dispatch(updateProfile(formData));
  //   }
  // };
  // Close modal after success
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag, onHide]);


  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_EMPLOYMENT", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_EMPLOYMENT" }));
    };
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Employment Types</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {employmentOptions.map((type) => {
              const isSelected = selectedTypes.some(
                (t) => t.value === type.value,
              );

              return (
                <div
                  key={type.value}
                  className={`checkbox-option col-lg-6 ${
                    isSelected ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(type)}
                >
                  <div className="contentwrap">
                    <input type="checkbox" checked={isSelected} readOnly />

                    <label className="checkbox-label">{type.label}</label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedTypes.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EmploymentTypeModal;
